var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusCommessaRedYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcb202;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #d22a17;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1",
    focusable: "false"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.6,5.8c-.4-.5-1-.8-1.6-.8H5c-1.1,0-2,.9-2,2v10c0,1.1.9,2,2,2h11c.7,0,1.3-.3,1.6-.8l4.4-6.2s-4.4-6.2-4.4-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.6,5.8c-.4-.5-1-.8-1.6-.8H5c-1.1,0-2,.9-2,2v5h19s-4.4-6.2-4.4-6.2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCommessaRedYellow);
export default __webpack_public_path__ + "static/media/status_commessa_red_yellow.00a2fce0ad442c3572673f730660aa72.svg";
export { ForwardRef as ReactComponent };